var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4111 10.3209C11.7055 10.3209 11.0794 10.64 10.6508 11.1341L6.5369 8.75895C6.62299 8.5147 6.67915 8.25548 6.67915 7.98128C6.67915 7.72673 6.62767 7.48529 6.55281 7.25507L10.6639 4.88181C11.0925 5.36657 11.712 5.67915 12.4111 5.67915C13.7035 5.67915 14.7507 4.63195 14.7507 3.33957C14.7507 2.04719 13.7035 1 12.4111 1C11.1187 1 10.0715 2.04719 10.0715 3.33957C10.0715 3.59598 10.123 3.83837 10.1988 4.06858L6.08864 6.44185C5.66003 5.9552 5.03956 5.64171 4.33957 5.64171C3.04719 5.64171 2 6.6889 2 7.98128C2 9.27366 3.04719 10.3209 4.33957 10.3209C5.02085 10.3209 5.62727 10.0261 6.05494 9.56096L10.1932 11.9501C10.1211 12.1747 10.0715 12.4106 10.0715 12.6604C10.0715 13.9528 11.1187 15 12.4111 15C13.7035 15 14.7507 13.9528 14.7507 12.6604C14.7507 11.368 13.7035 10.3209 12.4111 10.3209Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.de2a641fea69134ca7e4bf6abd2b8dc3.svg";
export { ForwardRef as ReactComponent };